import { apiClient } from '@borradh-workspace/api-client';
import type { QueryConfig } from '@borradh-workspace/api-client/react-query';
import { listCalendarAccountsResponseSchema } from '@borradh-workspace/contracts';
import { queryOptions, useQuery } from '@tanstack/react-query';
import type {
  CalendarAccount,
  ListCalendarAccountsResponse,
} from '../../types';

export const listCalendarAccountsQueryOptions = () => {
  return queryOptions({
    queryKey: ['integrations', 'calendar', 'accounts'],
    queryFn: () =>
      apiClient.get<ListCalendarAccountsResponse>(
        'integrations/calendar/accounts',
        { schema: listCalendarAccountsResponseSchema }
      ),
    staleTime: 60 * 1000, // 1 minute
  });
};

type UseListCalendarAccountsOptions = {
  includeMeetOnly?: boolean;
  queryConfig?: QueryConfig<typeof listCalendarAccountsQueryOptions>;
};

export const useListCalendarAccounts = ({
  queryConfig,
  includeMeetOnly = false,
}: UseListCalendarAccountsOptions = {}) => {
  const query = useQuery({
    ...listCalendarAccountsQueryOptions(),
    ...queryConfig,
  });

  return {
    accounts: (query.data?.accounts ?? ([] as CalendarAccount[])).filter(
      (account) => includeMeetOnly || account.purpose !== 'meet_only'
    ),
    isAvailable: query.data?.available ?? false,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
